/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppSignupStatusDataSchema = z.object({
	hasAccount: z.boolean(),
	onboardingStatus: z.string().nullable(),
	isActive: z.boolean(),
	hasCredentials: z.boolean(),
	whatsappEnabled: z.boolean(),
	wabaDisplayName: z.string().nullable(),
	nameStatus: z.string().nullable(),
	isNameCompliant: z.boolean().nullable(),
	canInitiateSignup: z.boolean().nullable(),
	provisioningStatus: z.string().nullable(),
	provisioningError: z.string().nullable(),
	resendCooldownRemaining: z.number().nullable(),
	lastVerificationMethod: z.string().nullable(),
	verificationRequestFailed: z.boolean().nullable(),
	verificationAutoAttempts: z.number().default(0),
	verificationAutoAttemptsCap: z.number().default(3),
	verificationOnHold: z.boolean().default(false),
	firstContactAutomationEnabled: z.boolean().default(false),
	firstContactTemplateId: z.string().nullable(),
	firstContactScoreThreshold: z.number().nullable(),
	deactivatedAt: z.string().nullable(),
	deactivationReason: z.string().nullable(),
	scheduledDeactivationAt: z.string().nullable(),
})

export type WhatsAppSignupStatusDataSchema = z.infer<typeof whatsAppSignupStatusDataSchema>
